import { storeSelectors, warehouseSelectors, carSelectors, adSelectors, employeesSelectors, customerSelectors, levelSelectors, productsSelectors } from '~/store';
import { TURN_PHASES, DEFAULT_STARTING_DATE, MISSOUT_SCENARIOS } from '~/lib/constants';
import { turnToMonth, turnToShortDate } from '~/lib/helpers';
import { tradeshowSelectors } from '../selectors';
// ---- internal imports ----

export function getTurnNum(state) {
	return state.turn.num;
}

export function getTurnPhase(state) {
	return state.turn.phase;
}

export function getTurnMsg(state) {
	return state.turn.msg;
}

export function getTurnDate(state) {
	return state.turn?.date;
}

export function getTurnMonth(state) {
	const date = new Date(state.turn.date);
	return date.toLocaleDateString(
		undefined,
		{ month: 'long' }
	);
}

export function getNextTurnMonth(state) {
	const nextTurnNum = getTurnNum(state) + 1;
	return turnToMonth(nextTurnNum);
}

export function getTurnShortDate(state) {
	return turnToShortDate(state.turn.num);
}

export function getNextMonthDate(state) {
	const currDate = new Date(getTurnDate(state));

	return new Date(currDate.getFullYear(), currDate.getMonth() + 1, 1);
}

export function isPreparationPhase(state) {
	return state.turn.phase === TURN_PHASES.PREPARATION;
}

export function isCustomersPhase(state) {
	return state.turn.phase === TURN_PHASES.CUSTOMERS;
}

export function isNextTurnLoading(state) {
	return state.turn.isNextTurnLoading;
}

export function getCurrentQuarterNum(state) {
	const currentTurnDate = new Date(getTurnDate(state));
	const quarterOfCurrentMonth = Math.ceil((currentTurnDate.getMonth() + 1) / 3);
	const numberOfYears = currentTurnDate.getFullYear() - DEFAULT_STARTING_DATE.getFullYear();
	const numberOfQuartersOfPreviousYears = 4 * numberOfYears;

	return quarterOfCurrentMonth + numberOfQuartersOfPreviousYears;
}

export function getLastNTurnMonths(state, nMonths) {
	const currentDate = getTurnDate(state);
	const lastMonthDate = new Date(currentDate);
	let dates = [];

	for (let i = 0; i < nMonths; i++)
		dates.push(new Date(lastMonthDate.getFullYear(), lastMonthDate.getMonth() - i, 15));

	return dates;
}

export function getMonthAndYear(state, dateStr = null) {
	const date = dateStr ?? getTurnDate(state);
	const dateObj = new Date(date);
	const month = dateObj.getMonth() + 1;
	const year = dateObj.getFullYear();

	return { month, year };
}

export function getNextMonthExpenses(state) {
	const storeRent = storeSelectors.getStoreRent(state);
	const salaries = employeesSelectors.getNextMonthEmployeeSalaries(state);
	const wareHouseRent = warehouseSelectors.getNextMonthWarehouseRent(state);
	const carRent = carSelectors.getNextMonthCarRent(state);
	const adsRent = adSelectors.getNextMonthRunningAdsRent(state);

	return storeRent + salaries + wareHouseRent + carRent + adsRent;
}

export function getSaveCheckpointAfterTurnLoaded(state) {
	return state.turn.saveCheckpointAfterTurnLoaded;
}

export function getHasPurchasedStockThisTurn(state) {
	return state.turn.hasPurchasedStockThisTurn;
}

export const getMissoutScenario = (state) => {
	const hasRemainingCustomers = customerSelectors.hasValidViewingCustomers(state);
	const hasExtraCustomers = customerSelectors.hasExtraCustomers(state);
	const currentTurnPhase = getTurnPhase(state);
	const isPrepPhase = currentTurnPhase === TURN_PHASES.PREPARATION;
	const currentLevel = levelSelectors.getLevelNumber(state);
	const hasPurchasedStockThisTurn = getHasPurchasedStockThisTurn(state)
	const hasLowStock = productsSelectors.hasLowStock(state);
	const hasTradeshowStartingThisMonth = tradeshowSelectors.hasTradeshowStartingThisMonth(state);
	const hasStock = productsSelectors.getProductsCountInStock(state) > 0;

	if (isPrepPhase) {
		if (currentLevel < 3 && (!hasPurchasedStockThisTurn || hasLowStock)) {
			return MISSOUT_SCENARIOS.EARLY_LEVEL_AND_NO_STOCK_PURCHASED;
		} else if (hasTradeshowStartingThisMonth) {
			return MISSOUT_SCENARIOS.TRADESHOW_NEXT_TURN;
		}
	} else if (hasStock) {
		if (hasRemainingCustomers) {
			return MISSOUT_SCENARIOS.HAS_VALID_VIEWING_CUSTOMERS;
		} else if (hasExtraCustomers) {
			return MISSOUT_SCENARIOS.HAS_EXTRA_CUSTOMERS;
		}
	}
	return null;
}
